import { roleGuarded } from '@/components/shell/RoleState';
import { BillingTab } from '@/features/settings/BillingTab';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/settings/billing')({
  staticData: { roles: ['owner'] },
  validateSearch: z.object({ result: z.string().optional() }),
  component: roleGuarded(BillingTab),
});
